import React, { createContext, useEffect, useReducer, useState } from 'react'
import { getCookie, setCookie } from 'helper/cookie'
import { Form } from 'antd'
export const CounterContext = createContext({})

import { getPermissionControl } from 'api/Admin/rolePermission'

const initialState = {
  counter: 0,
}
const token = getCookie('access_token_admin')

const counterReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_COUNTER':
      return {
        ...state, // copy state
        counter: state.counter + action.payload, // set state counter
      }
  }
}

export const CounterProvider = ({ children }) => {
  const [counterState, counterDispatch] = useReducer(counterReducer, initialState)
  const { counter } = counterState
  const addCounter = (payload, text) => counterDispatch({ type: 'ADD_COUNTER', payload }) // ส่ง type ADD_COUNTER และ payload เพื่อให้ conterReducer ไปใช้งานต่อ

  const mainRoleUser = getCookie('roleUser')

  const [adminPermission, setAdminPermission] = useState([])
  const [pathActive, setPathActive] = useState('')

  //check modal unsave project information
  const [isDirty, setDirty] = useState(false)
  const [click_path, setClick_path] = useState()
  const [form] = Form.useForm()

  // schedule
  const [data_common_reschedule, setData_common_reschedule] = useState()
  const [disableSave, setDisableSave] = useState(false)

  const getPermissionAdmin = async () => {

    await getPermissionControl({
      token: getCookie('access_token_admin'),
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          if (data.result?.permission == null) {
            setAdminPermission([])
          } else {
            setAdminPermission(data.result.permission)
          }
        } else {
          // alert('ไม่มี การตั้ง permission ใน admin')
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    getPermissionAdmin()
  }, [mainRoleUser])

  return (
    <CounterContext.Provider
      value={{
        counter,
        addCounter,
        mainRoleUser,
        adminPermission,
        getPermissionAdmin,
        pathActive,
        setPathActive,
        isDirty,
        setDirty,
        click_path,
        setClick_path,
        form,
        setData_common_reschedule,
        data_common_reschedule,
        disableSave,
        setDisableSave,
      }}
    >
      {children}
    </CounterContext.Provider>
  )
}
